import React, { useState } from "react";
import { Button, CircularProgress } from "@mui/material";
import { retrieveOrderByIdApi } from "../../../../components/api/OrderApiService";

const OrderButton = ({ row, id, setEditOrder }) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (loading) return; 
    setLoading(true);
    try {
      const orderData = await retrieveOrderByIdApi(id);
      if (!orderData) {
        alert("No data returned from the API.");
        return;
      }
      setEditOrder({
        visible: true,
        data: orderData?.data,
        index: row?.index,
      });
      console.log(orderData);
    } catch (error) {
      console.error("Error retrieving order:", error);
    } finally {
      setLoading(false); 
    }
  };

  return (
    <Button
      sx={{
        minWidth: 0,
        padding: "2px 4px",
        fontSize: "0.8rem",
        lineHeight: 1,
      }}
      onClick={handleClick}
      variant="text"
      disabled={loading || (row?.orderRecordStatus==="PASSIVE")}
      startIcon={loading && <CircularProgress size={16} />}
    >
      {id}
    </Button>
  );
};

export default OrderButton;
